import * as RadixDialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import { ReactNode } from 'react';
import './Modal.css';

export const Modal = ({
  open,
  setOpen,
  triggerElement,
  title,
  description,
  children,
}: {
  open?: boolean;
  setOpen?: (value: boolean) => void;
  triggerElement: React.ReactNode;
  title?: string;
  description?: string;
  children?: ReactNode;
}) => (
  <RadixDialog.Root open={open} onOpenChange={setOpen}>
    <RadixDialog.Trigger asChild>{triggerElement}</RadixDialog.Trigger>
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="DialogOverlay" />
      <RadixDialog.Content className="DialogContent">
        <RadixDialog.Title className="DialogTitle">{title}</RadixDialog.Title>
        <RadixDialog.Description className="DialogDescription">
          {description}
        </RadixDialog.Description>

        {children}

        <RadixDialog.Close asChild>
          <button className="IconButton" aria-label="Close">
            <Cross2Icon />
          </button>
        </RadixDialog.Close>
      </RadixDialog.Content>
    </RadixDialog.Portal>
  </RadixDialog.Root>
);
